<template>
  <Tabs
    :bottom-border="true"
    :list-class-names="$style.list"
    :selected-tab="selectedTab"
    :should-scroll-active-element-into-view="shouldScrollActiveElementIntoView"
  >
    <Tab
      v-for="tab in tabs"
      :key="tab.title"
      :title="tab.title"
      :to="tab.to"
    />
  </Tabs>
</template>

<script>
import { addIsCustomToPath, isSavedLocation } from '@@/utils/CommonUtils';

export default {
  name: 'SnowLocationNavigation',

  props: {
    location: {
      type: Object,
      default: null,
    },
    selectedTabTitle: {
      type: String,
      default: '',
    },
  },

  computed: {
    tabs() {
      const tabs = [
        {
          title: 'Weather',
          to: `/location/${this.location?.slug}/weather`,
        },
        {
          title: 'Snow Summary',
          to: `/location/${this.location?.slug}/snow-summary`,
        },
        {
          title: 'Snow Report',
          to: `/location/${this.location?.slug}/snow-report`,
        },
        {
          title: 'Cams',
          to: `/location/${this.location?.slug}/cams`,
        },
        {
          title: 'Weather Stations',
          to: `/location/${this.location?.slug}/weather-stations`,
        },
        {
          title: 'Daily Snows',
          to: `/location/${this.location?.slug}/daily-snows`,
        },
        {
          title: 'Trail Maps',
          to: `/location/${this.location?.slug}/trail-maps`,
        },
        {
          title: 'Info',
          to: `/location/${this.location?.slug}/info`,
        },
      ];

      if (this.location.avalanche_region_id) {
        const avalancheForecastTab = {
          title: 'Avalanche Forecast',
          to: `/location/${this.location?.slug}/avalanche-forecast`,
        };

        tabs.splice(6, 0, avalancheForecastTab);
      }

      // Hide Trail Maps, Avalanche Forecast, and Info tabs for custom locations or
      // locations that have not yet been saved to the database.

      if (this.location?.is_custom || !isSavedLocation(this.location)) {
        const supportedTabs = [
          'Weather',
          'Snow Summary',
          'Snow Report',
          'Cams',
          'Weather Stations',
          'Daily Snows',
          'Avalanche Forecast',
        ];

        return tabs
          .filter((tab) => supportedTabs.includes(tab.title))
          .map((tab) => {
            const { href, title, to } = tab;
            return to
              ? { title, to: addIsCustomToPath(to, this.location) }
              : { href, title };
          });
      }

      return tabs;
    },

    selectedTab() {
      return this.tabs.findIndex(({ title }) => this.selectedTabTitle === title);
    },

    shouldScrollActiveElementIntoView() {
      return this.selectedTab > 1;
    },
  },
};
</script>

<style module>
/**
 * Hide scrollbar yet allow content to still be scrolled!
 * SEE: https://stackoverflow.com/questions/16670931/hide-scroll-bar-but-while-still-being-able-to-scroll#answer-49278385
 */
.list {
  overflow-x: scroll;
  scrollbar-width: none; /* Firefox */
}

.list::-webkit-scrollbar { /* WebKit */
  height: 0;
  width: 0;
}
</style>
